var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"chat-hr"}),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Saisissez votre message"},on:{"change":_vm.sendMessage},model:{value:(_vm.form.message),callback:function ($$v) {_vm.$set(_vm.form, "message", $$v)},expression:"form.message"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }